import { useState } from "preact/hooks"
import { HintButton } from "./hint"
import { Icon } from "./icon.js"

export const Checkboxes = (props) => {
  const classList = () => {
    const classes = ["checkboxes"]
    props.singular || classes.push("multiple")
    props.class && classes.push(props.class)
    return classes.join(" ")
  }
  const isObserver = props.form.inFormValues({
    name: "reporter_type",
    value: "observer",
  })

  const fieldOverride = (field) => {
    let [value, label] = field
    if (props.alternative_field_labels && isObserver) {
      const newPair = props.alternative_field_labels?.find(
        (_field) => _field[0] === value,
      )
      label = newPair ? newPair[1] : label
    }
    return [value, label]
  }

  return (
    <fieldset class={classList()}>
      {props.label && <legend class="show-for-sr">{props.label}</legend>}
      {props.fields.map((f) => {
        const hint = props.hints?.[f[0]]

        return (
          <Checkbox
            key={`${props.form.stepId}-${props.name}-${f[0]}`}
            field={fieldOverride(f)}
            singular={props.singular}
            function={props.function}
            name={props.name}
            form={props.form}
            icons={props.icons ?? false}
            special_label={props.special_label ?? false}
            conditional_label={props.conditional_label ?? false}
          >
            {hint && (
              <HintButton
                title={hint.title}
                onClick={() => {
                  props.form.openHint(hint)
                }}
              />
            )}
          </Checkbox>
        )
      })}
    </fieldset>
  )
}

export const Checkbox = (props) => {
  const [value, initialLabel] = props.field
  const { name } = props

  const [disabled, setDisabled] = useState(false)

  const checkSingularCondition = (condition) => {
    let singular = false
    if (condition === "perpetrator_type") {
      singular = singlePerpetrator()
    }
    return singular
  }

  const isRequired = () => {
    return !props.form.requirementsMet(name)
  }

  const singlePerpetrator = () => {
    return props.form.inFormValues({
      name: "perpetrator_type",
      value: "single",
    })
  }

  const singular =
    typeof props.singular === "boolean"
      ? props.singular
      : checkSingularCondition(props.singular)

  const onChange = () => {
    setDisabled(true)
    props.form.toggleValue(
      {
        step: props.form.stepId,
        name,
        label,
        value,
      },
      singular,
      props.function === "switch"
        ? ["perpetrator_roles", "perpetrator_known", "perpetrator_genders"]
        : false,
    )

    props.function === "onClickNext" && props.form.showStep(1)

    setDisabled(false)
  }

  const label =
    props.conditional_label &&
    (value === "other" || value === "other_unknown") &&
    singlePerpetrator()
      ? props.conditional_label
      : initialLabel

  return (
    <div class="checkbox" key={`${name}-${value}`}>
      <input
        id={`${name}-${value}`}
        type="checkbox"
        value={value}
        name={name}
        disabled={disabled}
        checked={props.form.inFormValues({ name, value }) || false}
        onChange={onChange}
      />
      <label
        for={`${name}-${value}`}
        class={
          props.icons
            ? `w-icon ${value} ${isRequired() && "required"}`
            : `${isRequired() && "required"}`
        }
      >
        {label}
        {props.special_label && <span>{props.special_label}</span>}
        {props.icons && <Icon name={value} />}
      </label>
      {props.children}
    </div>
  )
}
